import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../WebApp';

function BalanceStatus() {
  const { user, updateUser, language } = React.useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const status = searchParams.get('status');

  useEffect(() => {
    const refreshUser = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get('/auth/me');
        if (updateUser) {
          updateUser(data);
        }
      } catch (error) {
        // ignore
      } finally {
        setLoading(false);
      }
    };
    refreshUser();
  }, [updateUser]);

  const isSuccess = status === 'success';

  return (
    <div className="max-w-2xl mx-auto text-center text-white space-y-6 py-12">
      <div className={`rounded-3xl border px-6 py-10 ${isSuccess ? 'border-green-700 bg-green-900/10' : 'border-red-700 bg-red-900/10'}`}>
        <h1 className="text-4xl font-bold mb-4">
          {isSuccess
            ? (language === 'en' ? 'Payment received' : 'Платёж получен')
            : (language === 'en' ? 'Payment failed' : 'Платёж не прошёл')}
        </h1>
        <p className="text-gray-300 text-base">
          {isSuccess
            ? (language === 'en'
              ? 'Tokens will appear in your balance after blockchain confirmation. You can continue chatting right now.'
              : 'Токены появятся на балансе после подтверждения сети. Вы можете продолжить общение уже сейчас.')
            : (language === 'en'
              ? 'Something went wrong. You can try again or contact support in Telegram @hotbump_bot.'
              : 'Что-то пошло не так. Попробуйте ещё раз или напишите нам в Telegram @hotbump_bot.')}
        </p>
        {loading && (
          <div className="text-gray-400 mt-3">{language === 'en' ? 'Refreshing balance...' : 'Обновляем баланс...'}</div>
        )}
        {user && (
          <div className="mt-6">
            <div className="uppercase text-xs text-gray-400">{language === 'en' ? 'Current balance' : 'Текущий баланс'}</div>
            <div className="text-3xl font-semibold">{user.token_balance || 0}</div>
          </div>
        )}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
          <Link
            to="/web/explore"
            className="px-6 py-3 rounded-xl border border-white/20 hover:bg-white/10 transition"
          >
            {language === 'en' ? 'Back to Explore' : 'Вернуться к моделям'}
          </Link>
          <Link
            to="/web/promo"
            className="px-6 py-3 rounded-xl bg-burgundy-600 hover:bg-burgundy-500 transition"
          >
            {language === 'en' ? 'Top up again' : 'Пополнить ещё раз'}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BalanceStatus;




